import React, { useRef } from 'react';
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import classes from './edit-product.module.scss';

const ImagesPicker = ({ images, onChange }) => {
  const inputFile: any = useRef(null);

  const addImages = () => {
    const newImages: any = [];
    let count = 0;
    Array.from(inputFile.current.files).forEach((file: any) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        count++;
        newImages.push({ base64: event.target.result, file });
        if (inputFile.current.files.length === count) {
          onChange([...images, ...newImages]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <div>
      <div style={{ margin: '10px 0' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {images.map((image: any) => (
            <div
              key={typeof image === 'string' ? image : image.base64}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px'
              }}
            >
              <img
                src={typeof image === 'string' ? image : image.base64}
                style={{ width: '100px' }}
              />

              <DeleteIcon
                className={classes.delete_icon}
                onClick={() => {
                  onChange(
                    images.filter(i => i !== image || i.base64 === image)
                  );
                }}
              />
            </div>
          ))}
        </div>
        <Button
          variant="outlined"
          data-e2e-id={'add-photo-button'}
          color="primary"
          onClick={() => inputFile.current.click()}
        >
          Додати фото
        </Button>
        <input
          type="file"
          multiple
          onChange={addImages}
          ref={inputFile}
          style={{ visibility: 'hidden', height: 0 }}
        />
      </div>
    </div>
  );
};

export default ImagesPicker;
